import { render, staticRenderFns } from "./postPosition.vue?vue&type=template&id=5e5c3b20&scoped=true&"
import script from "./postPosition.vue?vue&type=script&lang=js&"
export * from "./postPosition.vue?vue&type=script&lang=js&"
import style0 from "./postPosition.vue?vue&type=style&index=0&id=5e5c3b20&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5c3b20",
  null
  
)

export default component.exports